import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthQuery } from 'app/core/auth/auth.query';
import { Resource } from 'app/shared/acl/acl.model';
import { AclService } from 'app/shared/acl/acl.service';
import { map, mergeMap, take } from 'rxjs';


const NOTIF_RESOURCES = [
    Resource.NOTIF_FOLDER_PI,
    Resource.NOTIF_FOLDER_BL,
    Resource.NOTIF_AREA_PI,
    Resource.NOTIF_AREA_BL,
    Resource.NOTIF_AREA_MLS,
];


export const notifGuard = () => {
    const aclService = inject(AclService);
    const router = inject(Router);
    const authQuery = inject(AuthQuery);

    return authQuery.whenUserInfoLoaded$().pipe(
        mergeMap(() => aclService.allowed.pipe(map(_ => aclService.can(NOTIF_RESOURCES)))),
        take(1),
        map(can => can
            ? true
            : router.createUrlTree(['/'])
        ),
    );
};
